import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/JellyBreath/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'
const JellyBreath = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
     <Helmet>
        <title>Jelly Breath - Sweet Berry & Vanilla Flavor | BeyondBloom™</title>
        <meta
          name="description"
          content="Jelly Breath is a premium cannabis strain featuring dense, frosty buds with a delicious sweet berry and vanilla flavor. Explore its smooth effects today!"
        />
        <meta
          name="keywords"
          content="Jelly Breath strain, sweet berry cannabis, vanilla cannabis, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Jelly Breath - Sweet Berry & Vanilla Flavor | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Jelly Breath is a premium cannabis strain featuring dense, frosty buds with a delicious sweet berry and vanilla flavor. Explore its smooth effects today!"
        />
        <meta property="og:image" content="/images/jelly-breath.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/jelly-breath" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Jelly Breath - Sweet Berry & Vanilla Flavor | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Jelly Breath is a premium cannabis strain featuring dense, frosty buds with a delicious sweet berry and vanilla flavor. Explore its smooth effects today!"
        />
        <meta name="twitter:image" content="/images/jelly-breath.png" />
      </Helmet>
    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default JellyBreath